import script from "./Movie.vue?vue&type=script&lang=ts&setup=true"
export * from "./Movie.vue?vue&type=script&lang=ts&setup=true"

import "./Movie.vue?vue&type=style&index=0&id=f7f5d900&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f5d900"]])

export default __exports__